// @flow
import actions from "./actions";
import {strings} from "../../../config";
import type {GetState} from "../../Store";
import type {Dispatch} from "redux";
import {registerGeolocationWatchPosition} from "../../../Utils/LocationUtils";
import BackendOperations from "../../Middleware/Backend/operations";
import type {AlertData, CSSDirectionType} from "./utils";

const updateDirection = actions.updateDirection;

const initApp = (token: string, direction: CSSDirectionType) => {
    return (dispatch: Dispatch, getState: GetState) => {
        dispatch(BackendOperations.doDecryptToken(token));
        dispatch(updateDirection(direction));
        registerGeolocationWatchPosition(
            (coords: Coordinates) => {
                dispatch(updateRiderLocation({lat: coords.latitude, lng: coords.longitude}));
            },
            (err: Object) => {
                dispatch(updateRiderLocation());
            }
        );
    };
};

const acceptTermsClick = actions.acceptTerms;
const loadingSemaphoreIncrement = actions.loadingSemaphoreIncrement;
const loadingSemaphoreDecrement = actions.loadingSemaphoreDecrement;
const updateRiderLocation = actions.updateRiderLocation;
const showAlert = (alert: AlertData = Object.freeze({})) => {
    let finalAlertButtons;
    if (!alert.buttons || alert.buttons.length === 0) {
        finalAlertButtons = [{text: strings.alert_window_generic_accept_button_text}];
    } else {
        finalAlertButtons = alert.buttons;
    }
    const finalAlert = {
        title: alert.title || strings.alert_window_generic_error_title_text,
        content: alert.content || alert.message || strings.alert_message_technical_issue_text,
        buttons: finalAlertButtons,
    };
    return actions.alertDataSet(finalAlert);
};

const clearAlert = actions.alertDataClear;

const noOperation = actions.noOperation;
const failSilently = actions.noOperation;
const technicalIssue = actions.technicalIssue;

export default {
    initApp,
    acceptTermsClick,
    loadingSemaphoreIncrement,
    loadingSemaphoreDecrement,
    updateRiderLocation,
    showAlert,
    clearAlert,
    noOperation,
    failSilently,
    technicalIssue,
    updateDirection,
};



// WEBPACK FOOTER //
// ./src/Store/Ducks/App/operations.js